enum mode {
  ACTIVE,
  TRANSPORT,
}
enum yesNo {
  NO,
  YES,
}
enum reboot {
  NORMAL,
  REBOOTED,
}
enum ack {
  NOACK,
  ACK,
}
enum openClosed {
  CLOSED,
  OPEN,
}
enum detected {
  NOT_DETECTED,
  DETECTED,
}
enum charging {
  NOT_CHARGING,
  CHARGING,
}
enum errors {
  OK,
  ERRORS,
}
enum gpsFix {
  NO_FIX,
  FIX,
}
enum bitSet {
  NOT_SET,
  SET,
}
enum onOff {
  OFF,
  ON,
}

export type StatusBitTypeList = mode | yesNo | reboot | ack | openClosed | detected | charging | errors | gpsFix | bitSet | onOff

export type StatusTypes =
  | typeof mode
  | typeof yesNo
  | typeof reboot
  | typeof ack
  | typeof openClosed
  | typeof detected
  | typeof charging
  | typeof errors
  | typeof gpsFix
  | typeof bitSet
  | typeof onOff

export type StatusType = {
  [k: string]: StatusBitTypeList
}

export { mode, yesNo, ack, reboot, charging, openClosed, detected, errors, gpsFix, bitSet, onOff }
